export default {
  namespaced: true,
  inventory_equipment_type_catalog: {
    menu: "Catálogo de Tipos de Equipamento",
    title: "Tipo de Equipamento",
    name: "Nome",
    created_at: "Criado em",
    updated_at: "Atualizado em",
  },
};
